<main class="main">
  <lib-taas-main-layout 
    titleText="TaaS Admin Frontend" 
    [userDetails]="currentUser" 
    [menuItemList]="taasMenuItems"
    [activeRoute]="activeRoute" 
    [selectableLanguages]="supportedLanguages"
    (navigateHomeRequest)="navigateHome()"
    (contextMenuEvent)="handleUserContextMenuEvent($event)" 
    (routeUpdateRequest)="handleRouteUpdateRequest($event)">
    <router-outlet />
  </lib-taas-main-layout>
  <lib-taas-hidden-version-info [appVersion]="appVersion" [commonUiLibVersion]="commonUiLibVersion" />
  <lib-taas-toastr />
</main>